import React from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import Button, { type ButtonProps } from '@mui/material/Button';
import classNames from 'classnames';
import translate from '@/lib/intl/translate';

export default function FilterButton({
  className,
  iconOnly = false,
  onClick,
  count = 0,
  ...buttonProps
}: ButtonProps & { iconOnly?: boolean; count?: number }) {
  return (
    <Button
      className={classNames(className, { 'px-2': iconOnly })}
      onClick={onClick}
      title={translate('BUTTON_FILTER')}
      {...buttonProps}
    >
      <TuneIcon />
      {!!count && <div className="pl-2">({count})</div>}
    </Button>
  );
}
